<!--
 * @Description: 面包屑
 * @Author: xiawenlong
 * @Date: 2021-04-20 10:44:00
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-04-27 18:45:40
-->
<template>
  <div v-if="$route.path != '/dashbord'" class="bread-crumb">
    <el-breadcrumb separator="/">
      <transition-group name="breadcrumb">
        <el-breadcrumb-item
          v-for="(item, index) in breadList"
          :key="item.path + index"
          :to="index === breadList.length - 1 ? undefined : resolvePath(item, index)"
        >
          {{ item.meta.title }}
        </el-breadcrumb-item>
      </transition-group>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadList: [],
    }
  },
  watch: {
    $route: {
      handler(route) {
        let allList = route.matched.filter(item => {
          if (item.meta && item.meta.title) {
            return true
          }
        })
        if (allList.length && allList[0].path !== '/' && allList[0].path !== '/dashbord') {
          allList.unshift({ path: '/', meta: { title: '首页' } })
        }
        this.breadList = allList
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * 解析面包屑跳转路径
     * 对于包含参数占位符的路由模板路径，使用 $route.params 中的实际值替换占位符
     */
    resolvePath(item) {
      let path = item.path || ''
      const params = this.$route.params || {}
      // 将模板中的 :paramName 和 :paramName? 用实际参数值替换
      Object.keys(params).forEach(key => {
        const value = params[key]
        if (value !== undefined && value !== null) {
          // 匹配 :key? (可选参数) 或 :key (必选参数)
          const optionalRegex = new RegExp(`:${key}\\?`, 'g')
          const requiredRegex = new RegExp(`:${key}(?!\\?)`, 'g')
          path = path.replace(optionalRegex, value).replace(requiredRegex, value)
        } else {
          // 如果可选参数没有值，移除该参数段（包括前面的斜杠）
          const optionalRegex = new RegExp(`/:${key}\\?`, 'g')
          path = path.replace(optionalRegex, '')
        }
      })
      // 清理可能残留的未匹配参数占位符，移除其所在路径段
      path = path.replace(/\/:[^/?]+(\?)?/g, '')
      // 修正多余斜杠和尾部斜杠
      path = path.replace(/\/+/g, '/').replace(/\/$/, '') || '/'
      return path
    },
  },
}
</script>
